// extracted by mini-css-extract-plugin
export default {"ModalHeader":"R_MNVXqtLHLos1mjuGmx","ModalBody":"ctZ0TnsWpG8xLjH9epUm","Buttons":"WN7iGEqW0HdYvHIF8ZVX"};